/**
 * Источник правды для breakpoint mobile/desktop в JS-коде.
 * Синхронизирован с tailwind `xl` (1280px) и медиа-запросами в CSS.
 */
export const SIDEBAR_BREAKPOINT_PX = 1280;
